import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image--sprite",
  "use": "image--sprite-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol viewBox=\"0 0 33 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"image--sprite\">\n<path d=\"M26.1673 4H7.50065C6.03398 4 4.83398 5.2 4.83398 6.66667V25.3333C4.83398 26.8 6.03398 28 7.50065 28H26.1673C27.634 28 28.834 26.8 28.834 25.3333V6.66667C28.834 5.2 27.634 4 26.1673 4ZM26.1673 25.3333H7.50065V6.66667H26.1673V25.3333ZM19.4473 16.3867L15.7807 21.1067L13.1673 17.96L9.50065 22.6667H24.1673L19.4473 16.3867Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol